import { type ReactNode } from 'react';
import { BODY, Divider, PAGE_HEAD, PullQuote } from './rules-typography';
import { HeroStats, MissionPhases, Perspective } from './rules-1-mission';
import { Earn2500, HowYouEarn } from './rules-1-money';
import { DailyGoals, Payments, Strikes, VacationDays } from './rules-1-rules';
import { WeeklyBonuses } from './rules-1-bonuses';
import { ClosingTruth, GameDynamics, TimeLimit } from './rules-1-closing';

function Header(): ReactNode {
  return (
    <header className="space-y-md text-center">
      <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-brand-red">
        The 3333 Games
      </p>
      <h1 className={PAGE_HEAD}>Reglas del juego</h1>
      <p className={BODY}>
        Un juego adictivo. Con dinero real. Y una oportunidad limitada.
      </p>
      <PullQuote>
        Una decisión: jugar de verdad o no. Los que ejecutan, ganan. Los que
        procrastinan, pierden.
      </PullQuote>
    </header>
  );
}

export function RulesContent1(): ReactNode {
  return (
    <article className="space-y-2xl">
      <Header />
      <HeroStats />
      <MissionPhases />
      <Perspective />
      <Divider />
      <HowYouEarn />
      <Earn2500 />
      <Divider />
      <DailyGoals />
      <Strikes />
      <VacationDays />
      <Payments />
      <Divider />
      <WeeklyBonuses />
      <GameDynamics />
      <TimeLimit />
      <Divider />
      <ClosingTruth />
    </article>
  );
}
